__turbopack_context__.v({
  "details__content": "shared-module-scss-module__8TRlaG__details__content",
  "details__legend": "shared-module-scss-module__8TRlaG__details__legend",
  "details__logo-container": "shared-module-scss-module__8TRlaG__details__logo-container",
  "find-form": "shared-module-scss-module__8TRlaG__find-form",
  "find-form__filters": "shared-module-scss-module__8TRlaG__find-form__filters",
  "find-form__input": "shared-module-scss-module__8TRlaG__find-form__input",
  "find-form__label": "shared-module-scss-module__8TRlaG__find-form__label",
  "find-form__legend": "shared-module-scss-module__8TRlaG__find-form__legend",
  "find-form__title": "shared-module-scss-module__8TRlaG__find-form__title",
});
